import styled from "styled-components";
import { Line } from "@vds/lines";
import { Button } from "@vds/buttons";

export const StickyContainer = styled.div`
  position: ${({ position }) => position ? "absolute" : "sticky"};
  top: 0px;
  z-index: ${({zIndex}) => zIndex ? zIndex : "999"};
  background-color: white;
  width: 100%;
  margin: 0 auto;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row; 
  gap: 16px;
  row-gap: 10px;
  > * {
    height: 32px;
  }
  @media (max-width: 391px) {
    gap: 0;
    row-gap: 10px;
  }
  @media (max-width: 639px) {
    ${({ hasAddress }) => !hasAddress && "gap: unset;"}
  }
    @media screen and (min-width:767px){
    flex-wrap: wrap;
    justify-content: space-between;

    }
`;

export const LeftContainer = styled.div`
  display: flex;
  width: fit-content;
  ${({ pdp, cartPage, isMobile }) =>
    ((!pdp && !cartPage) || ((pdp || cartPage) && !isMobile)) && "margin-right: auto;"}
    ${({ cartPage, isMobile }) =>
    (cartPage && isMobile) && "margin-right: 0px;"}
`;

export const TotalsContainer = styled.div`
  height: unset;
   @media (max-width: 639px) {
    margin-right: ${({ hasAddress, pdp, isMobile }) =>
      !hasAddress && (!pdp || (pdp && !isMobile)) ? "unset" : "auto"};
   }
`;

export const TotalsDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TopLine = styled(Line)`
  margin-bottom: 14px;
`;

export const BottomLine = styled(Line)`
  margin-top: 16px;
`;

export const ShoppingBagContainer = styled.div`
  cursor: pointer;
  display: flex;
  svg {
    margin: auto;
  }
`;

export const AddressContainer = styled.div`
  display: flex;
  * {
    color: #000;
    border-color: #000;
  }
`;

export const BackIconWrapper = styled.div`
  cursor: pointer;
  margin: auto;
  padding-right:16px;
   @media screen and (max-width: 767px) {
  padding-right: 12px;
}
`;

export const RowBreak = styled.hr`
  width: 100%;
  border: 0;
  height: 0;
  margin: 0;
`;
export const ButtonWrapper = styled(Button)`
  @media screen and (max-width: 767px) {
    display: none !important;
  }
`;
export const ButtonWrapperCart = styled(Button)`
  @media screen and (max-width: 767px) {
    display: block !important;
    text-overflow:ellipsis;
    width:39%;

  } 
`;
export const ButtonWrapperMobile = styled(Button)`
  display: none;
  width: 100%;
  background-color: white !important;
  z-index: 100;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  border: none;
  border-radius: 0px;
  > span {
    width: 100%;
  }
  [class^="StyledChildWrapper"] {
    padding: 1rem !important;
  }
  @media screen and (max-width: 767px) {
    display: block !important;
  }
`;

export const StyledLineMobile = styled(Line)`
  display: none;
  @media screen and (max-width: 767px) {
    bottom: 75px;
    display: block !important;
    position: fixed;
    width: 100%;
    z-index: 101;
  }
`;

export const SkipButtonWrapper = styled(Button)`
  @media screen and (max-width: 767px) {
    width: 100%;
    height: 32px;
    background-color: white !important;
    color: black !important;
  }
`;